
import Events from '../Events';
import GHGeometryObject from './GHGeometryObject';

export default class GHToggleObject extends GHGeometryObject {
  constructor (ghObject) {
    super(ghObject);
    this.__value = false;
  }

  get value () {
    return this.__value;
  }

  set value (v) {
    this.__value = v;
  }

  change (v) {
    this.value = v;
    this.emit(Events.UI_CHANGE, this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHToggleParam.js